import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { ChevronDoubleRight } from 'react-bootstrap-icons'
import BannerImg from '../assets/images/banners/Banner1.webp'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { toast } from 'react-toastify'

const ReellyProperties = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [properties, setProperties] = useState([])
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [perPage] = useState(10) // You can adjust this as needed

    const fetchProperties = async (page = 1) => {
        try {
            setLoading(true)
            // Clear previous properties while loading
            setProperties([])

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/reely`, {
                params: {
                    page,
                    per_page: perPage,
                },
            })

            setProperties(response.data.items || [])
            // Adjust this based on your API's actual pagination response
            setTotalPages(Math.ceil(response.data.pagination.total / perPage))
        } catch (error) {
            setProperties([])
            toast.error('Failed to load properties. Please check your connection.')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchProperties(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage)
        }
    }

    const parseImageUrl = (imageUrl) => {
        try {
            const parsed = JSON.parse(imageUrl)
            return parsed.url || ''
        } catch {
            return ''
        }
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Reelly Properties - Dubai Real Estate Listings</title>
                <meta
                    name="description"
                    content="Browse the latest property listings from Reelly. Find your dream home in Dubai with our curated selection of properties."
                />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Reelly Properties - Dubai Real Estate Listings" />
                <meta
                    property="og:description"
                    content="Browse the latest property listings from Reelly. Find your dream home in Dubai with our curated selection of properties."
                />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Browse the latest property listings from Reelly. Find your dream home in Dubai with our curated selection of properties."
                />
                <meta name="twitter:title" content="Reelly Properties - Dubai Real Estate Listings" />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
            </Helmet>

            <Header />

            <section
                id="website-responsive"
                className="container-fluid common-banner shadow-800homes"
                style={{ backgroundImage: `url(${BannerImg})` }}
            >
                <div className="row justify-content-center align-items-center">
                    <div className="col-11 col-lg-10">
                        <h1 className="lh-sm fw-600 banner-title text-uppercase text-white text-center">
                            Reelly Properties
                        </h1>
                    </div>
                </div>
            </section>

            <section className="pt-5 mt-md-5" />

            <section id="website-responsive" className="container-fluid py-4 font-pri">
                <div className="row justify-content-center gap-5">
                    {loading ? (
                        <div className="col-md-12 col-sm-12 text-center">
                            <Spinner animation="border" variant="white" />
                        </div>
                    ) : (
                        <>
                            {properties.length > 0 ? (
                                <>
                                    {properties.map((property, index) => {
                                        const imageUrl = parseImageUrl(property.cover_image_url)
                                        return (
                                            <div
                                                key={property.id}
                                                className="w-blogs hover-blogs border-white border-1 border-bottom border-1 border border-white p-0"

                                            >
                                                <div className="image-box">
                                                    {imageUrl && (
                                                        <img
                                                            className="w-100"
                                                            src={imageUrl}
                                                            alt={property.name}
                                                            style={{ height: '250px', objectFit: 'cover' }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="py-4 px-3">
                                                    <h2 className="fs-ss-20 pt-2 text-white">
                                                        <div style={{ fontWeight: '500' }}>{property.name}</div>
                                                    </h2>
                                                    <div className="fs-ss-15 fw-300 pt-2 text-grey lh-1-7em">
                                                        <div>
                                                            <strong>Area:</strong> {property.area}
                                                        </div>
                                                        <div>
                                                            <strong>Developer:</strong> {property.developer}
                                                        </div>
                                                        <div>
                                                            <strong>Status:</strong> {property.status}
                                                        </div>
                                                        {property.completion_datetime && (
                                                            <div>
                                                                <strong>Completion:</strong>{' '}
                                                                {new Date(
                                                                    property.completion_datetime,
                                                                ).toLocaleDateString()}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="fs-ss-14 pt-3">
                                                        <a
                                                            href={`https://www.google.com/maps?q=${property.coordinates}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-decoration-none fw-500 text-ss-primary"
                                                        >
                                                            View on Map <ChevronDoubleRight className="" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </>
                            ) : (
                                <div className="col-md-12 col-sm-12 text-center">
                                    <div
                                        className="fs-zk-22 text-white text-montserrat mb-2"
                                        style={{ fontWeight: '600' }}
                                    >
                                        No Properties Found
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="row justify-content-center mt-4">
                        <div className="col-auto">
                            <nav>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                                            Previous
                                        </button>
                                    </li>

                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(page)}>
                                                {page}
                                            </button>
                                        </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                )}
            </section>

            <section className="pt-5 mt-md-5" />

            <Footer />
        </>
    )
}

export default ReellyProperties
